import React, { useEffect } from 'react';
import { Card } from 'antd';
import { useHistory } from 'react-router-dom';

export default ({ children }) => {
  const history = useHistory();

  useEffect(() => {
    if (localStorage.getItem('token')) {
      history.push('/');
    }
  }, [history]);

  return (
    <div className="AuthLayout">
      <Card className="AuthContent">
        <div className="Logo">
          <img
            src="https://images.ceptesok.com/cdn-cgi/image/width=49,height=49,fit=pad,quality=100/logos/service-types/market-logo.svg"
            alt="Cepte Şok"
            style={{ width: 100 }}
          />
        </div>
        {children}
      </Card>
    </div>
  );
};
